import { getResults } from '../../search/api'
import { buildNameSearchQuery, buildBaseQuery, buildOrQuery, getInstitutionIdFilter, getUpdatedFacet, buildMustQuery } from '../../search/searchUtils'
import { populateMajors, populateMinors, populateCareers, populateIndustries, getMajorInformation,
  getProgramResults, getCareerResults, getExploreSubstreamEntities, deleteSubstreamEntity, addSubstreamEntity,
  getReport, logExploreActivity, getAllBookmarks, getBookmarks, createBookmark, deleteBookmark,
  getCareerUsingUuid, getProgramGuideUsingUuid, getMajorMinorUsingUuid, getCareerInformation, getCareerResultsUsingSocCode,
  getProgramResultsUsingSocCode, getProgramCreditProgress, getCareerSkillProgress, getFastestGrowingCareers,
  getCareersWithLargestEmployment, getAllProgramCreditProgress, getAlumniReport, getInstitutionCareers , getRecommendedCareers} from '../api'

export const loadReport = ({ state, commit }, query) => {
  return getReport(query).then(res => {
    return res
  })
}

export const loadAlumniReport = ({ state, commit }, title) => {
  return getAlumniReport(title).then(res => {
    return res
  })
}

export const loadAllBookmarks = ({ state, commit }) => {
  return getAllBookmarks().then(res => {
    commit('LOAD_BOOKMARKS', res)
    return res
  })
}

export const loadBookmarks = ({ state, commit }, {name, page, count}) => {
  return getBookmarks(name, page, count).then(res => {
    commit('LOAD_BOOKMARKS', res)
    return res
  })
}

export const loadCreateBookmarks = ({ state, commit }, bookmark) => {
  return createBookmark(bookmark).then(res => {
    return res
  })
}

export const loadDeleteBookmark = ({ state, commit }, bookmarkId) => {
  return deleteBookmark(bookmarkId).then(res => {
    return res
  })
}

export const loadCareerUsingUuid = ({ state, commit }, uuid) => {
  return getCareerUsingUuid(uuid).then(res => {
    return res
  })
}

export const loadProgramGuideUsingUuid = ({ state, commit }, uuid) => {
  return getProgramGuideUsingUuid(uuid).then(res => {
    return res
  })
}

export const loadMajorMinorUsingUuid = ({ state, commit }, uuid) => {
  return getMajorMinorUsingUuid(uuid).then(res => {
    return res
  })
}
export const loadMajors = ({ state, commit }) => {
  return populateMajors().then(res => {
    commit('LOAD_MAJORS', res)
    return res
  })
}

export const loadMinors = ({ state, commit }) => {
  return populateMinors().then(res => {
    commit('LOAD_MINORS', res)
    return res
  })
}

export const loadProgramScrollTop = ({ state, commit }, programScrollTop) => {
  commit('LOAD_PROGRAM_SCROLL_TOP', programScrollTop)
}

export const loadProgramScrollLeft = ({ state, commit }, programScrollLeft) => {
  commit('LOAD_PROGRAM_SCROLL_LEFT', programScrollLeft)
}

export const loadCareerScrollTop = ({ state, commit }, careerScrollTop) => {
  commit('LOAD_CAREER_SCROLL_TOP', careerScrollTop)
}

export const loadCareerScrollLeft = ({ state, commit }, careerScrollLeft) => {
  commit('LOAD_CAREER_SCROLL_LEFT', careerScrollLeft)
}

export const loadCareersPivot = ({ state, commit }) => {
  return populateCareers().then(res => {
    commit('LOAD_CAREERS', res)
    return res
  })
}

export const loadIndustries = ({ state, commit }) => {
  return populateIndustries().then(res => {
    commit('LOAD_INDUSTRIES', res)
    return res
  })
}

export const loadMajorInformation = ({ state, commit }, major) => {
  return getMajorInformation(major).then(res => {
    return res
  })
}

export const loadCareerInformation = ({ state, commit }, { career, institutionId }) => {
  return getCareerInformation(career, institutionId).then(res => {
    return res
  })
}

export const loadCareerResults = ({ state, commit }, cipCode) => {
  return getCareerResults(cipCode).then(res => {
    commit('LOAD_CAREER_RESULTS', res)
    return res
  })
}

export const loadProgramResults = ({ state, commit }, cipCode) => {
  return getProgramResults(cipCode).then(res => {
    commit('LOAD_PROGRAM_RESULTS', res)
    return res
  })
}

export const loadCareerResultsUsingSocCode = ({ state, commit }, socCode) => {
  return getCareerResultsUsingSocCode(socCode).then(res => {
    commit('LOAD_CAREER_RESULTS', res)
    return res
  })
}

export const loadProgramResultsUsingSocCode = ({ state, commit }, socCode) => {
  return getProgramResultsUsingSocCode(socCode).then(res => {
    commit('LOAD_PROGRAM_RESULTS', res)
    return res
  })
}

export const setCurrentFacet = ({ state, commit }, currentFacet) => {
  commit('LOAD_CURRENT_FACET', currentFacet)
  return currentFacet
}

export const loadExploreSubstreamEntities = ({ state, commit }, {streamUuid}) => {
  console.log('streamUuid')
  if (!streamUuid) {
    return []
  }
  return getExploreSubstreamEntities(streamUuid).then(response => {
    commit('LOAD_EXPLORE_SUBSTREAMS', response)
    // kick off another explore search to update isAddedToStream flags
    commit('UPDATE_EXPLORE_TIMESTAMP', new Date())
    return response
  })
}

export const exploreStreamSelected = ({ state, commit }, {streamUuid}) => {
  commit('UPDATE_EXPLORE_STREAM', streamUuid)
}

export const addEntityToExploreStream = ({ state, commit }, {entity}) => {
  let streamUuid = state.selectedStreamUuid
  console.log('in addEntityToExploreStream streamUuid: ', streamUuid)
  console.log('in addEntityToExploreStream entity: ', entity)
  return addSubstreamEntity(streamUuid, entity).then((response) => {
    return response
  })
}

export const removeSubstreamEntity = ({ state, commit }, {streamUuid, entityUuid}) => {
  return deleteSubstreamEntity(streamUuid, entityUuid).then((response) => {
    return response
  })
}

export const updateExploreSearchState = ({ state, commit }, {selectedMajor, selectedMinor, selectedIndustry, selectedCareer}) => {
  commit('UPDATE_SELECTED_MAJOR', selectedMajor)
  commit('UPDATE_SELECTED_MINOR', selectedMinor)
  commit('UPDATE_SELECTED_INDUSTRY', selectedIndustry)
  commit('UPDATE_SELECTED_CAREER', selectedCareer)
}

export const resetExploreData = ({ state, commit }) => {
  commit('UPDATE_SELECTED_MAJOR', '')
  commit('UPDATE_SELECTED_MINOR', '')
  commit('UPDATE_SELECTED_INDUSTRY', '')
  commit('UPDATE_SELECTED_CAREER', '')
  commit('LOAD_CURRENT_FACET', 'all')
  commit('LOAD_PROGRAM_RESULTS', [])
  commit('LOAD_CAREER_RESULTS', [])
}

export const loadExploreResults = ({ state, commit }, data) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    // Process hits
    var hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    var total = (res && res.hits && res.hits.total && res.hits.total.value) ? res.hits.total.value : 0
    var processedHits = []
    for (var i = 0; i < hits.length; i++) {
      // let isAddedToStream = false
      // let substreams = state.substreams
      // substreams.forEach((substream) => {
      //   if (hits[i]._source.type === 'stream') {
      //     if (substream.originUuid === hits[i]._source.streamId) {
      //       isAddedToStream = true
      //     }
      //   }
      // })
      var result = {
        uuid: hits[i]._id,
        index: hits[i]._index,
        type: hits[i]._source.type,
        title: (hits[i]._source.title && hits[i]._source.title.length > 0) ? hits[i]._source.title : hits[i]._source.streamTitle,
        description: hits[i]._source.description,
        thumbnail: hits[i]._source.thumbnail,
        thumbnailURIList: hits[i]._source.thumbnailURIList,
        streamTitle: hits[i]._source.streamTitle,
        streamId: hits[i]._source.streamId,
        resourceType: hits[i]._source.type,
        entityType: (hits[i]._source.type) ? hits[i]._source.type.toUpperCase() : '',
        total: total
        // isAddedToStream: isAddedToStream
      }
      processedHits.push(result)
    }
    return processedHits
  })
}

export const loadLogExploreActivity = ({ state, commit }, {action, page, link, entityUuid}) => {
  var uObj = JSON.parse(localStorage.getItem('userobj'))
  var role = localStorage.getItem('userrole')
  var institution = localStorage.getItem('institution')
  var data = '&action=' + action +
             '&userUuid=' + uObj.uuid +
             '&userFirstName=' + uObj.firstName +
             '&userLastName=' + uObj.lastName +
             '&userRole=' + role +
             '&institutionName=' + institution +
             '&institutionUuid=' + uObj.institutionId +
             '&studentType=' +
             '&advisor=' +
             '&major=' + uObj.major1Title +
             '&concentration=' + uObj.concentration1Title +
             '&minor=' + uObj.minor1Title +
             '&product=' +
             '&productPackage=' +
             '&productArea=' +
             '&page=' + page +
             '&link=' + link +
             '&MajorCIP=' +
             '&GPA=' + uObj.majorGpa +
             '&MajorGPA=' + uObj.overallGpa +
             '&entityUuid=' + entityUuid

  return logExploreActivity(data)
}

export const loadExploreSearchResults = ({ state, commit }, {data, resetFacets, facetNames, selectedFacetNames, currentFacetResults}) => {
  if (data.indexList.length === undefined || data.libraryList.length === undefined) {
    return {}
  }
  return getResults(data).then((res) => {
    let hits = (res && res.hits && res.hits.hits) ? res.hits.hits : []
    let total = (res && res.hits && res.hits.total && res.hits.total.value) ? res.hits.total.value : 0
    let processedHits = []
    for (var i = 0; i < hits.length; i++) {
      let result = {
        uuid: hits[i]._source.uuid,
        index: hits[i]._index,
        resourceType: hits[i]._index,
        type: hits[i]._source.type,
        title: hits[i]._source.title,
        name: hits[i]._source.name,
        description: hits[i]._source.description,
        elasticSearchDocument: hits[i]._source
      }
      processedHits.push(result)
    }

    const inputState = {
      resetAllFacets: resetFacets === true,
      selectedFacetNames: selectedFacetNames,
      currentFacets: currentFacetResults || {},
      responseFacets: res.aggregations || {}
    }

    let formattedFacets = {}
    facetNames.forEach(facetName => {
      formattedFacets[facetName] = getUpdatedFacet(facetName, inputState)
    })

    // commit('UPDATE_EXPLORE_FACET_RESULTS', formattedFacets)
    // commit('UPDATE_EXPLORE_RESULTS', processedHits)
    const response = {
      total: total,
      hits: processedHits,
      facets: formattedFacets
    }
    return response
  })
}

export const searchForProgramGuides = ({ state, commit }, {terms, sort, source, from, size, indexList, libraryList, privateLibraryList, publicLibraryList, userId, facets, filter, facetNames, selectedFacetNames}) => {
  const libraryFilter = getInstitutionIdFilter(publicLibraryList.concat(privateLibraryList))
  let query = {
    'constant_score': {
      'filter': buildOrQuery(libraryFilter),
      'boost': 1.0
    }
  }
  let filterByMajor = {
    'bool': {
      'must': [{
        'bool': {
          'should': [{
            'terms': {
              'type': ['major', 'minor', 'wft', 'cert', 'certificate']
            }
          }]
        }
      }]
    }
  }
  // Not using constant score query, we need relevence query.
//  query.constant_score.filter.bool.must.push(filterByMajor)
    query = buildOrQuery(libraryFilter)
    query.bool.must.push(filterByMajor)
  if (terms) {
    // query = buildOrQuery(libraryFilter)
    let queryString = {
      'query_string': {
        'query': 'TBA',
        // 'default_field': 'title'
        'fields' : ['title', 'description']
      }
    }
    // Give boost to phrase.
    queryString.query_string.query = '"'+(terms.split(',').join(' '))+'"* '
    queryString.query_string.query += (terms.split(',').join(' '))
    // Enable wildcard so it will do for each term
    queryString.query_string.analyze_wildcard=true
    query.bool.must.push(queryString)
  }

  let elasticSearchRequest = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: query,
    aggs: facets
  }

  if (Object.keys(filter).length > 0) {
    elasticSearchRequest['post_filter'] = filter
  }

  let requestPayload = {
    'indexList': indexList,
    'libraryList': libraryList,
    'useDefaultFields': 'false',
    'payload': elasticSearchRequest
  }
  const params = {
    data: requestPayload,
    resetFacets: false,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacetResults: state.programGuideFacetResults
  }
  return loadExploreSearchResults({ state, commit }, params).then(response => {
    commit('LOAD_PROGRAM_TOTAL', response.total)
    commit('UPDATE_PROGRAM_GUIDE_RESULTS', response.hits)
    commit('UPDATE_PROGRAM_GUIDE_FACET_RESULTS', response.facets)
    return response
  })
}

export const searchForCareers = ({ state, commit }, {terms, sort, source, from, size, userId, facets, filter, facetNames, selectedFacetNames, institutionCareers}) => {
  let query = terms && terms.length > 0 ? buildNameSearchQuery(terms) : buildMustQuery()
  /*let institutionCareerFilter = {
    'terms': {
      'code.keyword': institutionCareers
    }
  }
  query.bool.must.push(institutionCareerFilter)*/

  let elasticSearchRequest = {
    sort: sort,
    _source: source,
    from: from,
    size: size,
    query: query,
    aggs: facets
  }

  if (Object.keys(filter).length > 0) {
    elasticSearchRequest['post_filter'] = filter
  }

  let requestPayload = {
    'indexList': ['career'],
    'libraryList': [userId],
    'useDefaultFields': 'false',
    'payload': elasticSearchRequest
  }
  const params = {
    data: requestPayload,
    resetFacets: false,
    facetNames: facetNames,
    selectedFacetNames: selectedFacetNames,
    currentFacetResults: state.careerFacetResults
  }
  return loadExploreSearchResults({ state, commit }, params).then(response => {
    commit('LOAD_CAREER_TOTAL', response.total)
    commit('UPDATE_CAREER_RESULTS', response.hits)
    commit('UPDATE_CAREER_FACET_RESULTS', response.facets)
    return response
  })
}

export const saveProgramGuideSearchState = ({ state, commit }, {terms, sort, filter, selectedFacetNames, customIncomeMin, customIncomeMax}) => {
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_TERMS', terms)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_SORT', sort)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_FILTER', filter)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_SELECTED_FACET_NAMES', selectedFacetNames)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MIN', customIncomeMin)
  commit('UPDATE_PROGRAM_GUIDE_SEARCH_INCOME_MAX', customIncomeMax)
}

export const resetProgramGuideSearchState = ({ state, commit }) => {
  const params = {
    terms: '',
    sort: {},
    filter: {},
    selectedFacetNames: [],
    customIncomeMin: '',
    customIncomeMax: ''
  }
  return saveProgramGuideSearchState({ state, commit }, params)
}

export const saveCareerSearchState = ({ state, commit }, {terms, sort, filter, selectedFacetNames, customIncomeMin, customIncomeMax, institutionCareerFilter}) => {
  commit('UPDATE_CAREER_SEARCH_TERMS', terms)
  commit('UPDATE_CAREER_SEARCH_SORT', sort)
  commit('UPDATE_CAREER_SEARCH_FILTER', filter)
  commit('UPDATE_CAREER_SEARCH_SELECTED_FACET_NAMES', selectedFacetNames)
  commit('UPDATE_CAREER_SEARCH_INCOME_MIN', customIncomeMin)
  commit('UPDATE_CAREER_SEARCH_INCOME_MAX', customIncomeMax)
  commit('UPDATE_CAREER_SEARCH_INSTITUTION_CAREER_FILTER', institutionCareerFilter)
}

export const resetCareerSearchState = ({ state, commit }) => {
  const params = {
    terms: '',
    sort: {},
    filter: {},
    selectedFacetNames: [],
    customIncomeMin: '',
    customIncomeMax: '',
    institutionCareerFilter: true
  }
  return saveCareerSearchState({ state, commit }, params)
}

export const loadProgramCreditProgress = ({ state, commit }, {streamId, programId, recalculate}) => {
  return getProgramCreditProgress(streamId, programId, recalculate)
}

export const loadCareerSkillProgress = ({ state, commit }, {streamId, careerId, recalculate}) => {
  return getCareerSkillProgress(streamId, careerId, recalculate)
}

export const loadFastestGrowingCareers = ({ state, commit }) => {
  return getFastestGrowingCareers()
}

export const loadCareersWithLargestEmployment = ({ state, commit }) => {
  return getCareersWithLargestEmployment()
}

export const loadAllProgramCreditProgress = ({ state, commit }) => {
  return getAllProgramCreditProgress()
}

export const loadInstitutionCareers = ({ state, commit }) => {
  return getInstitutionCareers().then(res => {
    let codes = []
    res.forEach((item, i) => {
      codes.push(item.code)
    })

    commit('LOAD_INSTITUTION_CAREERS', codes)
    return res
  })
}
export const loadRecommendedCareers = ({ state, commit }) => {
  return getRecommendedCareers().then(res => {
    commit('LOAD_RECOMMENDED_CAREERS', res)
    return res
  })
}




// WEBPACK FOOTER //
// ./src/app/explore/vuex/actions.js